import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { MainAppService } from '../../services/main-app.service';
import { AppMainComponent } from '../app-main/app-main.component';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Config } from '../../models/config.model';
import { FrontendFieldError } from 'src/modules/sm-base/shared/FrontendFieldError';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: false
})
export class AppTopbarComponent {

    _RestEndpoint = RestEndpoint;
    _Config = Config;

    app = inject(MainAppService);
    appComponent = inject(AppMainComponent);

    getUserName(): string {
        return this.app.getUserName();
    }

    getUserNameShort(): string {
        let name = this.getUserName();
        return name != null && name.length > 0 ? name.substring(0, 1) : "?";
    }

    async changePassword(): Promise<void> {
        let form = this.app.tForm("general.changePassword", new FrontendForm([
            new FrontendField("oldPassword", "", FrontendFieldType.password, { mandatory: true, passwordFeedback: false }),
            new FrontendField("newPassword", "", FrontendFieldType.password, { mandatory: true }),
            new FrontendField("newPasswordRepeat", "", FrontendFieldType.password, { 
                mandatory: true, 
                passwordFeedback: false,
                validator: (field, item) => field.getValueString() != item.getValueString("newPassword") ? [new FrontendFieldError(field.id, this.app.t("general.changePassword.newPasswordRepeat_error1"))] : []})
        ]));
        if (await this.app.dialog.form(form, this.app.t("general.changePassword.title")) != "ok") {
            return;
        }

        try {
            await this.app.auth.changePassword(form.getValueString("oldPassword"), form.getValueString("newPassword"));
            this.app.showToast("success",  this.app.t("general.changePassword.changed_title"),  this.app.t("general.changePassword.changed"));
        }
        catch (ex) {
            this.app.showErrorToast(this.app.t("general.changePassword.error"));
        }
    }

    async logout(): Promise<void> {
        await this.app.auth.logout();
    }

    buttonClick(button: MenuItem): void {
        if (button.command != null) {
            button.command(null);
        }
    }

    async languageClicked(): Promise<void> {
        let languages = await RestEndpoint.main().run("api/app/languages").listStrings();
        this.app.openContextMenu(languages.map(lng => ({
                label: lng == "de" ? "Deutsch" : lng == "en" ? "English" : lng == "fr" ? "Français" : lng == "es" ? "Español" : lng,
                icon: RestEndpoint.getUrl() + "/api/app/flag/" + lng,
                command: async () => {
                    if (Config.get().warningOnSwitchLanguage && !await this.app.dialog.yesNo(this.app.t("general.languageChangeWarning", null, "Warnung: Beim Ändern der Sprache gehen eventuell ungespeicherte Änderungen verloren. Fortfahren?"), this.app.t("general.warning"))) {
                        return;
                    }
                    await this.app.setLanguage(lng);
                    this.app.reloadPage();
                }
            })));
    }

    async helpClicked(event: any): Promise<void> {
        let files = await RestEndpoint.main().query({ language: this.app.language }).run("api/app/helpFiles").listStrings();
        this.app.openContextMenu(files.map(file => ({
                label: file,
                command: async () => {
                    await RestEndpoint.main().query({ language: this.app.language, name: file }).runAndOpenInNewTab("api/app/helpFile");
                }
            })));
    }

    menuButtonClick(): void {
        this.app.openContextMenu([
            this.app.mainConfig.authRules.canChangePassword ? {
                label: this.app.t("general.changePassword.title"),
                icon: "fas fa-key",
                command: async () => this.changePassword()
            } : null,
            {
                label: this.app.t("general.logout"),
                icon: "fas fa-sign-out-alt",
                command: async () => this.logout()
            }
        ], "topbar-context-menu");
    }
}
